/* eslint-disable jsx-a11y/label-has-associated-control */

import React from "react";
import { useContext } from "../../../context";

export function Clinic() {
  const { appointment } = useContext();

  return (
    <div className="detail-row">
      <label>Clinic:</label>
      <span>{appointment.clinic.name}</span>
    </div>
  );
}
